export const selectStyles = (
  darkMode: boolean,
  isDisabled: boolean = false,
) => ({
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: darkMode ? "#4B5563" : "#E5E7EB",
    borderColor: darkMode ? "#374151" : "#9CA3AF",
    minWidth: "60px",
    boxShadow: state.isFocused
      ? `0 0 0 2px ${darkMode ? "#86BC25" : "#86BC25"}`
      : base.boxShadow,
    borderWidth: "1px",
    outline: "none",
    borderRadius: "0.375rem",
    transition: "box-shadow 0.2s, border-color 0.2s",
  }),
  container: (base: any) => ({
    ...base,
  }),
  singleValue: (base: any) => ({
    ...base,
    color: isDisabled ? "#53565A" : darkMode ? "#D1D5DB" : "#374151",
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: darkMode ? "#374151" : "#FFFFFF",
    marginTop: 0,
    minWidth: "130px",
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    display: isDisabled ? "none" : "block",
    paddingRight: "2px",
    paddingLeft: "2px",
    color: "#374151",
  }),
});
